import { Injectable } from '@angular/core';
import { CoverApiService } from '@app/services/api/cover.service';
import { FlashService } from '@app/services/flash.service';
import { Router } from '@angular/router';
import { ApiService } from '@app/services/api/api.service';
import {
    Load,
    LoadFail,
    LoadSuccess,
    Create,
    CreateSuccess,
    CreateFail,
    CoverActionTypes,
    ExportGroupCovers,
    ExportGroupCoversSuccess,
    ExportGroupCoversFail,
    ExportGroupCoversDownload,
    ExportGroupCoversDownloadSuccess,
    ExportGroupCoversDownloadFail
} from '@core/actions/cover.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap,concatMap } from 'rxjs/operators';


@Injectable()
export class CoverEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private fs: FlashService,
    private coversApi: CoverApiService,
    private api: ApiService,
  ) {}

  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(CoverActionTypes.Load),
    map(action => action.options),
    switchMap(action => {
      return this.coversApi.get(action).pipe(
          map((covers: any) => {
              return new LoadSuccess(covers)
          }),
          catchError(error => of(new LoadFail(error)))
      )
    })
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(CoverActionTypes.Create),
    map(action => action.data),
    switchMap(data =>
      this.coversApi.create(data).pipe(
        map((savedPort: any) => {
          return new CreateSuccess(savedPort);
        }),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(CoverActionTypes.CreateSuccess),
    map(action => action.cover),
    tap(([cover]: any) => {
        this.fs.emit({
            message: 'Descargado correctamente',
            type: 'success'
        })
    })
  );

  @Effect({ dispatch: false })
  createFail$: Observable<Action> = this.actions$.pipe(
    ofType<CreateFail>(CoverActionTypes.CreateFail),
    map(action => action.error),
    tap( res => {
        this.fs.emit({
            message: 'Error al generar las carátulas',
            type: 'danger'
        })
    })
  );

  @Effect({ dispatch: false })
  exportCoversGroup$ = this.actions$.pipe(
    ofType<ExportGroupCovers>(CoverActionTypes.ExportGroupCovers),
    tap(action => {
      this.api.exportCoversGroup(action.data);
    })
  );

  @Effect()
  exportCoversGroupSuccess$ = this.actions$.pipe(
    ofType<ExportGroupCoversSuccess>(CoverActionTypes.ExportGroupCoversSuccess),
    map(action => {
      return new ExportGroupCoversDownload(action.data.downloadUrl, action.data.name, action.data.total);
    })
  );

  @Effect({ dispatch: false })
  exportCoversGroupFail$ = this.actions$.pipe(
    ofType<ExportGroupCoversFail>(CoverActionTypes.ExportGroupCoversFail),
    map(action => {
      this.fs.emit({ type: 'warning', message: action.error.message });
    })
  );

  @Effect({ dispatch: false })
  exportCoversGroupDownload$ = this.actions$.pipe(
    ofType<ExportGroupCoversDownload>(CoverActionTypes.ExportGroupCoversDownload),
    map(action => [action.downloadUrl, action.name, action.total]),
    tap(([downloadUrl, name, total]) => {
        this.api.downloadCoversGroup(downloadUrl, name);
    })
  );

  @Effect({ dispatch: false })
  exportCoversGroupDownloadSuccess$ = this.actions$.pipe(
    ofType<ExportGroupCoversDownloadSuccess>(
      CoverActionTypes.ExportGroupCoversDownloadSuccess
    ),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Carátulas descargadas' });
    })
  );
}
